var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"inbox_hamburger_button",class:{
        'inbox_hamburger_button--toggled': _vm.toggled,
    },attrs:{"buttonHeight":56}},[_c('span',{staticClass:"inbox_hamburger_button__dots"},[_c('div',{staticClass:"button_dot button_dot--dot_1"}),_c('div',{staticClass:"button_dot button_dot--dot_2"}),_c('div',{staticClass:"button_dot button_dot--dot_3"})])])}
var staticRenderFns = []

export { render, staticRenderFns }